<template>
    <div
        class="v-select-dropdown pc"
        v-if="isShow"
        :class="[theme, { multiple: multiple }, dropStyle]"
        :style="{ height: dropdownHeight + 'px' }"
    >
        <slot name="footer"></slot>
        <div class="dropdown-search" v-if="filterable">
            <span class="iconfont icon-search-bold"></span>
            <input
                class="input"
                :value="filterValue"
                :placeholder="$t('common:placeholder.search')"
                type="text"
                @keyup="handleKeyUp"
            />
            <div
                class="help-item"
                v-show="!filterOptions || filterOptions.length === 0"
            >
                {{ noDataText }}
            </div>
        </div>
        <div class="list-wrap">
            <List
                :options="filterOptions"
                :itemHeight="itemHeight"
                :multiple="multiple"
                v-bind="$attrs"
                @clickOption="option => $emit('clickOption', option)"
            >
                <template #default>
                    <slot name="default"></slot>
                </template>
            </List>
        </div>

        <slot name="footer"></slot>
    </div>
</template>
<script>
import List from '../list.vue';
export default {
    i18next: { ns: 'common' },
    components: {
        List
    },
    emits: ['clickOption', 'change'],
    props: {
        options: {
            type: Array,
            default: () => []
        },
        height: {
            type: Number,
            default: 292
        },
        itemHeight: {
            type: Number,
            default: 42
        },
        noDataText: {
            type: String,
            default: 'No Data'
        },
        isShow: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        hasFilter: {
            type: Number,
            default: undefined
        },
        theme: {
            type: String,
            default: 'standard'
        },
        offset: {
            type: Object,
            default() {
                return {
                    left: 0,
                    top: 0
                };
            }
        }
    },
    data: function() {
        return {
            filterValue: ''
        };
    },
    computed: {
        //  Controls the display of the dropdown search box
        filterable({ options, hasFilter }) {
            if (typeof hasFilter !== 'undefined') {
                return Boolean(hasFilter);
            }
            return options.length > 10;
        },
        filterOptions({ options, filterValue }) {
            if (!(options instanceof Array)) {
                return [] 
            }
            return options.filter(option =>
                option.label.toUpperCase().includes(filterValue.toUpperCase()));
        },
        dropdownHeight({ height, options }) {
            return options.length <= 6 ? -1 : height;
        },
        dropStyle({ offset }) {
            if (window?.innerWidth && offset.left + 300 > window.innerWidth) {
                return 'drop_right';
            }
            return 'drop_left';
        }
    },
    methods: {
        handleKeyUp(event) {
            this.filterValue = event.target.value;
        }
    }
};
</script>
<style lang="scss">
.v-select-dropdown.pc {
    position: absolute;
    width: 100%;
    top: 100%;
    z-index: var(--level-high);
    background: #fff;
    overflow: auto;
    border: solid 1px var(--color-border);
    min-width: 300px;
    display: flex;
    flex-direction: column;
    &.layout1 {
        background: var(--g-bg-color);
    }
    &.drop_left {
        left: 0;
    }
    &.drop_right {
        right: 0;
    }
    .dropdown-search {
        height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #e2e4ea;
        font-size: 16px;
        margin: 0px 10px 5px;
        padding-right: 10px;
        .input {
            flex: 1 0 0;
            border: none;
            box-shadow: none;
            padding-left: 5px;
            outline: 0px solid;
            background: transparent;
        }
        .input:focus {
            border: none;
            outline: 0px solid;
        }
        .iconfont {
            color: #6b7282;
            font-size: 16px;
        }
    }
    .list-wrap {
        height: 100%;
    }
    .dropdown-search + .list-wrap {
        height: calc(100% - 50px);
    }
}
</style>
